@if (assistanceId() !== null || !readonly()) {
  <div class="assistance-attachments">
    @if (attachments().length > 0) {
      <div class="attachment-chips">
        @for (attachment of attachments(); track attachment.id) {
          <p-chip
            class="attachment-row"
            [label]="attachment.name"
            [icon]="attachmentIcon(attachment)"
            [removable]="!readonly()"
            (onRemove)="removeAttachment($event, attachment)"
            (click)="onChipClick($event, attachment)"
            [pTooltip]="'ASSISTANCE_ATTACHMENTS.TOOLTIP_OPEN_DOWNLOAD' | transloco"
            [attr.data-cy]="!readonly() ? 'removeAttachment' : null"
          />
        }
      </div>
    } @else if (!readonly()) {
      <div class="no-attachments">{{ 'ASSISTANCE_ATTACHMENTS.NO_ATTACHMENTS' | transloco }}</div>
    }

    @if (!readonly()) {
      <div class="attachment-actions">
        <button
          pButton
          type="button"
          icon="pi pi-upload"
          [label]="'ASSISTANCE_ATTACHMENTS.UPLOAD_FILE' | transloco"
          class="p-button-sm p-button-outlined"
          [disabled]="workInProgress()"
          (click)="selectFile()"
          data-cy="uploadAttachment"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-folder-open"
          [label]="'ASSISTANCE_ATTACHMENTS.PICK_FROM_DOCUMENTS' | transloco"
          class="p-button-sm p-button-outlined"
          [disabled]="workInProgress() || assistanceId() === null"
          [pTooltip]="assistanceId() === null ? ('ASSISTANCE_ATTACHMENTS.PICK_REQUIRES_SAVE' | transloco) : null"
          (click)="openDocumentPicker()"
          data-cy="pickAttachment"
        ></button>
        <input #fileInput type="file" [attr.accept]="allowedAccept" hidden (change)="onFileInput()" />
      </div>
    }
  </div>
}
